import $ from 'domtastic';
import Select from './Select';
import { events, url } from '../utils';

class Departments {
  static createSelects() {
    new Select({
      source: '.js-select-source-department',
      caption: '.js-select-caption-department',
      config: {
        initialValue: 'Alla',
        type: 'departments',
      },
    });
  }

  static setDepartmentFromUrl(param) {
    if (!param) return;
    const $select = $('.js-select-source-department');
    const $options = $('.js-select-source-department').find('option');

    $options.removeAttr('selected');
    const $department = $select.find(`option[data-department="${param}"]`);

    if (!$department[0]) return;
    $department.attr('selected', '');
    const value = Departments.valueFromParam(param);
    $select.val(value);
    $select.trigger('change');
  }

  static valueFromParam(param) {
    const firstLetter = param.substr(0, 1).toUpperCase();
    const restLetters = param.substr(1, param.length);
    return String(firstLetter + restLetters);
  }

  constructor() {
    Departments.createSelects();
    this.cacheDom();
    this.bindEvents();
    Departments.setDepartmentFromUrl(url.getParam('filter'));
  }

  cacheDom() {
    this.$departments = $('.js-department-section');
  }

  bindEvents() {
    events.on('select', (event) => {
      if (event.type !== 'departments') return;
      this.showDepartments(event.value);
    });
  }

  showDepartments(name) {
    this.$departments.removeClass('-visible');
    let $departments = $(`.js-department-section[data-department="${name}"]`);
    if (name.toLowerCase() === 'alla') $departments = $('.js-department-section');
    $departments.addClass('-visible');
  }
}

export default new Departments();



// WEBPACK FOOTER //
// ./components/Departments.js